<router-outlet></router-outlet>

<!-- Loading premium personalizado con logo de El Peruano -->
<app-premium-loading
  [show]="utilitarioService.loading"
  [message]="'Cargando contenido...'"
  [minDisplayTime]="600"
  size="medium">
</app-premium-loading>

<!-- Toast personalizado para rate limiting (pequeño, arriba derecha) -->
<app-rate-limit-toast></app-rate-limit-toast>
